module.exports = __webpack_public_path__ + "static/media/fondo.83cebc22.jpg";